import { TextInput } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { useDebounce } from '@frontend/utils';

type DebouncedInputProps = {
    debounceTimeoutMs?: number;
    onChange: (value: string | number | undefined) => void;
    size?: 'medium' | 'large';
    value?: string | number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'size'>;

export function DebouncedInput({
    value: loadedValue,
    onChange,
    debounceTimeoutMs = 500,
    size = 'medium',
    ...props
}: Readonly<DebouncedInputProps>) {
    const [value, setValue] = useState<string | number>();
    const debounce = useDebounce(debounceTimeoutMs);

    useEffect(() => {
        setValue(loadedValue);
    }, [loadedValue]);

    useEffect(() => {
        if (value !== loadedValue) {
            debounce(() => onChange(value));
        }
    }, [value]);

    return (
        <TextInput
            {...props}
            onChange={(e) => setValue(e.target.value)}
            onReset={() => setValue('')}
            size={size}
            type="text"
            value={value?.toString() ?? ''}
        />
    );
}
